import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Image from '../../../base/react/components/web/Image';
import LoadingIndicator from '../../../base/react/components/web/LoadingIndicator';
import { BANNER_WAITING_FOR_HOST } from '../../../recording/components/Recording/styles.web';
import moment from 'moment';
const useStyles = makeStyles()(theme => {
    return {
        waitingForHost: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '28px',
            height: 'calc(100vh - 96px)',
            marginTop: '96px',
            width: '100%',
            overflowY: 'auto',
            '& #preview': {
                width: '298px',
                height: '168px',
                alignItems: 'start',
                '& .avatar': {
                    marginTop: '16px',
                    width: '60px !important',
                    height: '60px !important',
                    fontSize: '24px !important',
                    transform: 'none'
                },
                '& .toolbox-actions': {
                    bottom: 0,
                    padding: 0,
                    '& .main-buttons': {
                        columnGap: '4px',
                        '& .item-toolbox-custom.toolbox-icon': {
                            minWidth: 'auto'
                        }
                    }
                }
            }
        },
        infoUser: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '32px',
            padding: '0 28px',
            '@media (min-width: 580px)': {
                flexDirection: 'row',
                columnGap: '32px',
                padding: '0 40px'
            },
            '@media (min-width: 1024px)': {
                paddingLeft: 'min(220px, 11.46vw)',
                paddingRight: 'min(220px, 11.46vw)'
            }
        },
        infoRoom: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '16px',
            '& p': {
                color: theme.palette.default00
            }
        },
        bannerWaiting: {
            padding: '0 28px',
            maxHeight: 'calc(100vh * 0.6)',
            paddingBottom: '80px',
            '@media (min-width: 580px)': {
                padding: '0 40px',
                paddingBottom: '80px',
            },
            '@media (min-width: 1024px)': {
                paddingLeft: 'min(220px, 11.46vw)',
                paddingRight: 'min(220px, 11.46vw)'
            }
        },
        roomName: {
            fontSize: '24px',
            fontWeight: 700
        },
        roomTime: {
            fontSize: '18px',
            fontWeight: 500,
            '& .time': {
                fontWeight: 700
            }
        },
        roomDesc: {
            fontSize: '18px',
            fontWeight: 600
        }
    };
});
const WaitingForHost = ({ preview, isRoomNotStart, isLoaded, roomInfo }) => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    return (React.createElement("div", { className: clsx(classes.waitingForHost) },
        React.createElement("div", { className: clsx(classes.infoUser) },
            preview,
            React.createElement("div", { className: clsx(classes.infoRoom) },
                React.createElement("h1", { className: classes.roomName }, roomInfo?.roomName),
                React.createElement("p", { className: classes.roomTime },
                    t('prejoin.startAt'),
                    " ",
                    React.createElement("span", { className: 'time' }, moment(roomInfo?.tsStart * 1000).format('HH:mm'))),
                React.createElement("p", { className: classes.roomDesc }, isRoomNotStart ? t('prejoin.waitingForHostStart') : t('prejoin.waitingForHostAccept')),
                !isLoaded && React.createElement(LoadingIndicator, null))),
        React.createElement(Image, { alt: 'waiting-for-host', src: BANNER_WAITING_FOR_HOST, className: clsx(classes.bannerWaiting) })));
};
export default WaitingForHost;
